<!-- main content -->
<div class="sticky-table-container">
    <p-table stripedRows [value]="items"
        dataKey="id"
        #dtIndirectRateStructure
        [style]="{ 'min-width': '100%' }"
        editMode="row"
        [(selection)]="selected"
    >
        <ng-template pTemplate="emptymessage">
            <tr>
                <td
                    [attr.colspan]="getRateColumns()"
                    style="text-align: center"
                >
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header let-item>
            <tr>
                <!-- Edit -->
                <th class="edit-cell"></th>
                <!-- status-->
                <th class="status-cell">
                    <i
                        class="pi pi-exclamation-circle"
                        title="Status"
                    ></i>
                </th>
                <!-- Cost Center -->
                <th pSortableColumn="Costcenterdesc">
                    Cost Center
                    <p-sortIcon
                        pSortableColumn="Costcenterdesc"
                        field="Costcenterdesc"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                    <p-columnFilter field="Costcenterid" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                        <ng-template #filter let-value let-filter="filterCallback">
                            <p-multiSelect
                                defaultLabel="Filter"
                                maxSelectedLabels="1"
                                appendTo="body"
                                [options]="costCenters"
                                [filter]="true"
                                styleClass="w-full"
                                [ngModel]="value"
                                (ngModelChange)="filter($event)"
                            ></p-multiSelect>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <!-- GA -->
                <th pSortableColumn="GAR" *ngIf="findRate('GAR')">
                    G&A
                    <p-sortIcon
                        pSortableColumn="GAR"
                        field="GAR"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
                <!-- FR -->
                <th pSortableColumn="FRR" *ngIf="findRate('FRR')">
                    Fringe
                    <p-sortIcon
                        pSortableColumn="FRR"
                        field="FRR"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
                <!-- OH -->
                <th pSortableColumn="OHR" *ngIf="findRate('OHR')">
                    Overhead
                    <p-sortIcon
                        pSortableColumn="OHR"
                        field="OHR"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
                <!-- MH -->
                <th pSortableColumn="MHR" *ngIf="findRate('MHR')">
                    Handling
                    <p-sortIcon
                        pSortableColumn="MHR"
                        field="MHR"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
                <!-- M2 -->
                <th pSortableColumn="M2R" *ngIf="findRate('M2R')">
                    Handling-2
                    <p-sortIcon
                        pSortableColumn="M2R"
                        field="M2R"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
                <!-- Fac -->
                <th pSortableColumn="Allocatefacility">
                    Facility
                    <p-sortIcon
                        pSortableColumn="Allocatefacility"
                        field="Allocatefacility"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template
            #body
            let-item
            let-edit="editing"
            let-ri="rowIndex"
            let-rowData
        >
            <tr
                [pSelectableRow]="item"
                [pEditableRow]="item"
                data-id="row-{{ item.id }}"
                [ngClass]="{
                    'ui-editing-row': edit && editing?.id === rowData?.id
                }"
            >
                <!-- Edit -->
                <td class="edit-cell">
                    <!-- for a new row -->
                    <button
                        *ngIf="item?.id === -1 && !edit"
                        pButton
                        type="button"
                        pInitEditableRow
                        icon="pi pi-plus"
                        class="
                            p-button-rounded p-button-text p-button-success
                        "
                        (click)="onRowEditInit(item)"
                    ></button>
                    <button
                        *ngIf="
                            !edit &&
                            (!editing?.id || editing?.id === item?.id) &&
                            item.id !== -1
                        "
                        pButton
                        type="button"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-text"
                        (click)="onRowEditInit(item)"
                        title="Edit"
                    ></button>
                    <button
                        *ngIf="edit"
                        pButton
                        type="button"
                        pSaveEditableRow
                        icon="pi pi-check"
                        class="
                            p-button-rounded p-button-text p-button-success
                        "
                        (click)="onRowEditSave(item)"
                    ></button>
                    <button
                        *ngIf="edit"
                        pButton
                        type="button"
                        pCancelEditableRow
                        icon="pi pi-times"
                        class="
                            p-button-rounded p-button-text p-button-danger
                        "
                        (click)="onRowEditCancel(item)"
                    ></button>
                </td>
                <!-- Status-->
                <td class="status-cell">
                    <div (click)="onStatusClick(item)">
                        <ef-status-icon
                            [status]="item?.Status?.StatusCode"
                            [message]="item?.Status?.Message"
                        ></ef-status-icon>
                    </div>
                </td>
                <!-- Cost Center -->
                <td class="disabled">
                    <p-cellEditor>
                        <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                            <input
                                pInputText
                                [(ngModel)]="item.Costcenterdesc"
                            />
                        </ng-template>
                        <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                            {{ item?.Costcenterdesc }}
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ item?.Costcenterdesc }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- GA -->
                <td *ngIf="findRate('GAR')">
                    <p-cellEditor>
                        <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                            <p-select
                                [autoDisplayFirst]="false"
                                [style]="{ width: '100%' }"
                                [options]="
                                    getRatesForCostCenter(item, 'GAR')
                                        | orderBy: 'label'
                                "
                                appendTo="body"
                                [(ngModel)]="item.GAR"
                                defaultLabel="Rate Type"
                                [filter]="true"
                            ></p-select>
                        </ng-template>
                        <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                            {{ item?.GAR?.toFixed(2) }}
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ item?.GAR?.toFixed(2) }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- FR -->
                <td *ngIf="findRate('FRR')">
                    <p-cellEditor>
                        <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                            <p-select
                                [autoDisplayFirst]="false"
                                [style]="{ width: '100%' }"
                                [options]="
                                    getRatesForCostCenter(item, 'FRR')
                                        | orderBy: 'label'
                                "
                                appendTo="body"
                                [(ngModel)]="item.FRR"
                                defaultLabel="Rate Type"
                                [filter]="true"
                            ></p-select>
                        </ng-template>
                        <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                            {{ item?.FRR?.toFixed(2) }}
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ item?.FRR?.toFixed(2) }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- OH -->
                <td *ngIf="findRate('OHR')">
                    <p-cellEditor>
                        <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                            <p-select
                                [autoDisplayFirst]="false"
                                [style]="{ width: '100%' }"
                                [options]="
                                    getRatesForCostCenter(item, 'OHR')
                                        | orderBy: 'label'
                                "
                                appendTo="body"
                                [(ngModel)]="item.OHR"
                                defaultLabel="Rate Type"
                                [filter]="true"
                            ></p-select>
                        </ng-template>
                        <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                            {{ item?.OHR?.toFixed(2) }}
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ item?.OHR?.toFixed(2) }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- MH -->
                <td *ngIf="findRate('MHR')">
                    <p-cellEditor>
                        <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                            <p-select
                                [autoDisplayFirst]="false"
                                [style]="{ width: '100%' }"
                                [options]="
                                    getRatesForCostCenter(item, 'MHR')
                                        | orderBy: 'label'
                                "
                                appendTo="body"
                                [(ngModel)]="item.MHR"
                                defaultLabel="Rate Type"
                                [filter]="true"
                            ></p-select>
                        </ng-template>
                        <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                            {{ item?.MHR?.toFixed(2) }}
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ item?.MHR?.toFixed(2) }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- M2 -->
                <td *ngIf="findRate('M2R')">
                    <p-cellEditor>
                        <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                            <p-select
                                [autoDisplayFirst]="false"
                                [style]="{ width: '100%' }"
                                [options]="
                                    getRatesForCostCenter(item, 'M2R')
                                        | orderBy: 'label'
                                "
                                appendTo="body"
                                [(ngModel)]="item.M2R"
                                defaultLabel="Rate Type"
                                [filter]="true"
                            ></p-select>
                        </ng-template>
                        <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                            {{ item?.M2R?.toFixed(2) }}
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ item?.M2R?.toFixed(2) }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- Fac -->
                <td>
                    <p-cellEditor>
                        <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                            <p-checkbox
                                binary="true"
                                [(ngModel)]="item.Allocatefacility"
                            ></p-checkbox>
                        </ng-template>
                        <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                            <i
                                [ngClass]="{
                                    pi: true,
                                    'pi-check': item?.Allocatefacility,
                                    'pi-times': !item?.Allocatefacility,
                                    green: item?.Allocatefacility,
                                    red: !item?.Allocatefacility
                                }"
                            ></i>
                        </ng-template>
                        <ng-template pTemplate="output">
                            <i
                                [ngClass]="{
                                    pi: true,
                                    'pi-check': item?.Allocatefacility,
                                    'pi-times': !item?.Allocatefacility,
                                    green: item?.Allocatefacility,
                                    red: !item?.Allocatefacility
                                }"
                            ></i>
                        </ng-template>
                    </p-cellEditor>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
